import React from 'react'
import { createContext } from 'lib/createContext'
import { Loading, Message } from '@workwhile/ui'
import { useJurisdictionQuery } from 'queries/wage/useJurisdictionQuery'

type JurisdictionDetailContextState = {
  state: NonNullable<ReturnType<typeof useJurisdictionQuery>['data']>
  actions: Record<string, never>
}

const [Context, useJurisdictionDetailContextValue] =
  createContext<JurisdictionDetailContextState>({
    name: 'JurisdictionDetailContext',
  })

export const JurisdictionDetailProvider = ({
  jurisdictionId,
  children,
}: {
  jurisdictionId: number
  children: React.ReactNode
}) => {
  const { data, isLoading, isError } = useJurisdictionQuery(jurisdictionId)

  if (isLoading) {
    return <Loading />
  }

  if (isError) {
    return (
      <Message variant="error">
        Sorry, something went wrong. Please reach out to eng support if this
        persists.
      </Message>
    )
  }

  if (!data) {
    return null
  }

  const value: JurisdictionDetailContextState = {
    state: data,
    actions: {},
  }

  return <Context.Provider value={value}>{children}</Context.Provider>
}

export { useJurisdictionDetailContextValue }
